import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// Üçüncü tema: yalnız <html data-theme="terminal"> iken uygulanır.
// index.css'ten SONRA yükleniyor ki eşit özgüllükte o kazansın.
import './terminal.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
